(() => {
  const userAgent = navigator.userAgent;
  const isSafari =
    /Safari/i.test(userAgent) &&
    !/(Chrome|Chromium|CriOS|Edg|EdgiOS|OPR|FxiOS)/i.test(userAgent);

  if (isSafari) document.documentElement.classList.add("is-safari");
})();

document.addEventListener("DOMContentLoaded", function () {
  const initializeFera = () => {
    if (!window.fera || !window.fera.getRating) return;
    const ratingStars = document.querySelector(".pdp-rating-stars");
    const ratingStarsBg = document.querySelector(".pdp-rating-bg");
    const ratingStarsFg = document.querySelector(".pdp-rating-fg");
    const ratingStarsCount = document.querySelector(".pdp-rating-count");
    if (!ratingStars) return;
    fera.getRating().then((rating) => {
      const { average, count } = rating;
      if (count === 0) return;

      ratingStars.classList.remove("hidden");
      ratingStarsFg.style.width = `${average * 20}%`;
      ratingStarsCount.textContent = `(${count})`;
    });
  };

  const maxAttempts = 50;
  let attemptCount = 0;

  if (fera.getRating) {
    initializeFera();
  } else {
    const feraInterval = setInterval(() => {
      attemptCount++;
      if (typeof fera !== "undefined") {
        clearInterval(feraInterval);
        initializeFera();
      } else if (attemptCount >= maxAttempts) {
        clearInterval(feraInterval);
        console.error("Fera failed to load within the expected time.");
      }
    }, 100);
  }

  const designSlides = document.querySelectorAll(
    ".design-slide [data-variant]"
  );
  subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
    const variant = e.data.variant;
    designSlides.forEach((designSlide) => {
      designSlide.classList.toggle(
        "hide",
        designSlide.dataset.variant != variant.id
      );
    });
  });

  subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (e) => {
    const optionName = e.data.target.name;
    if (!optionName.includes("Frame") && !optionName.includes("Mat")) return;
    const productSection = e.data.target.closest(".product");
    if (!productSection) return;
    const mediaGallery = productSection.querySelector("media-gallery");
    if (!mediaGallery) return;
    mediaGallery.goToDesignSlide();
  });
  changeSlideIfFromPdp();
});

function changeSlideIfFromPdp() {
  if (document.querySelector('[id^="HWArtistPDP-"]')) return;
  if (!window.location.href.includes("?variant")) return;
  const mediaGallery = document.querySelector("media-gallery");
  mediaGallery.goToSlideIndex(1);
}

class ImageLoad extends HTMLElement {
  constructor() {
    super();
    this.loadedImages = 0;
  }

  connectedCallback() {
    this.images = this.querySelectorAll("img");
    if (!this.images.length) return;

    this.images.forEach((image) => {
      if (image.complete) {
        this.settleImage(image);
      } else {
        image.addEventListener("load", () => this.settleImage(image), { once: true });
        image.addEventListener("error", () => {
          image.hidden = true;
          this.imageLoaded();
        }, { once: true });
      }
    });
  }

  settleImage(image) {
    if (typeof image.decode !== "function") {
      this.imageLoaded();
      return;
    }

    image.decode()
      .catch(() => {})
      .finally(() => this.imageLoaded());
  }

  imageLoaded() {
    this.loadedImages++;
    if (this.loadedImages >= this.images.length) {
      this.classList.add("loaded");
    }
  }
}

if (!customElements.get("image-load")) {
  customElements.define("image-load", ImageLoad);
}

class CustomSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.swiperEl = this.querySelector('.custom-slider__swiper');
    if (!this.swiperEl) return;
    this.setSpacingVariables();
    this.primeCompositeImages();
    this.syncBelowCardInfoHeights();
    this.initSwiper();
  }

  setSpacingVariables() {
    const spacingDesktop = this.dataset.spacingDesktop;
    const spacingMobile = this.dataset.spacingMobile;
    if (spacingDesktop) {
      this.style.setProperty('--slider-spacing-desktop', `${spacingDesktop}px`);
    }
    if (spacingMobile) {
      this.style.setProperty('--slider-spacing-mobile', `${spacingMobile}px`);
    }
  }

  primeCompositeImages() {
    if (this.compositesPrimed) return;
    this.compositesPrimed = true;

    const slides = Array.from(this.querySelectorAll('.swiper-slide'));
    if (!slides.length) return;

    const immediateCount = Math.min(
      window.matchMedia('(max-width: 749px)').matches ? 3 : 5,
      slides.length
    );

    const warmSlide = (slide) => {
      slide.querySelectorAll('.design-slide img').forEach((image) => {
        image.fetchPriority = 'low';
        image.loading = 'eager';
      });
    };

    slides.slice(0, immediateCount).forEach(warmSlide);

    const warmRemainingSlides = () => {
      let index = immediateCount;
      const warmNext = () => {
        if (index >= slides.length) return;
        warmSlide(slides[index]);
        index += 1;

        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(warmNext, { timeout: 1500 });
        } else {
          window.setTimeout(warmNext, 250);
        }
      };
      warmNext();
    };

    if (document.readyState === 'complete') {
      warmRemainingSlides();
    } else {
      window.addEventListener('load', warmRemainingSlides, { once: true });
    }
  }

  syncBelowCardInfoHeights() {
    if (this.classList.contains('text-on-card')) return;

    // Keep below-image slider cards the same height. The fixed CSS caption
    // allowance matches collection cards, so wrapped titles grow upward into
    // the image area instead of making an individual slide taller.
    this.infoResizeObserver?.disconnect();
    this.querySelectorAll('.nc__image-wrapper').forEach((imageWrapper) => {
      imageWrapper.style.removeProperty('--padding-bottom');
    });
  }

  initSwiper() {
    const spacingMobile = parseInt(this.dataset.spacingMobile, 10) || 12;
    const spacingDesktop = parseInt(this.dataset.spacingDesktop, 10) || 16;
    const shiftPdpOffsetRight = this.classList.contains('hw-related') || this.classList.contains('hw-you-may-like');
    const slideCount = this.swiperEl.querySelectorAll('.swiper-slide').length;
    const isShortProductSlider =
      this.classList.contains('product-carousel') &&
      !this.classList.contains('custom-slider--stack-desktop') &&
      slideCount === 4;
    if (isShortProductSlider) {
      this.classList.add('product-carousel--short');
      this.style.setProperty('--short-slider-count', slideCount);
      this.style.setProperty(
        '--short-slider-total-gap',
        `${spacingDesktop * (slideCount - 1)}px`
      );
      this.style.setProperty(
        '--short-slider-offset-total',
        shiftPdpOffsetRight ? '0px' : '80px'
      );
    }

    this.swiper = new Swiper(this.swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: spacingMobile,
      centeredSlides: false,
      freeMode: true,
      slidesOffsetBefore: shiftPdpOffsetRight ? 0 : 8,
      slidesOffsetAfter: shiftPdpOffsetRight ? 16 : 8,
      navigation: {
        prevEl: this.querySelector('[data-prev]'),
        nextEl: this.querySelector('[data-next]'),
      },
      mousewheel: { forceToAxis: true },
      breakpoints: {
        1024: {
          spaceBetween: spacingDesktop,
          freeMode: false,
          slidesOffsetBefore: shiftPdpOffsetRight ? 0 : 40,
          slidesOffsetAfter: isShortProductSlider
            ? (shiftPdpOffsetRight ? 0 : 40)
            : (shiftPdpOffsetRight ? 80 : 40),
        },
        2000: {
          spaceBetween: spacingDesktop,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
    });
  }

  disconnectedCallback() {
    this.infoResizeObserver?.disconnect();
    this.infoResizeObserver = null;
    this.destroySwiper();
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get("custom-slider")) {
  customElements.define("custom-slider", CustomSlider);
}

function getPageWidthPadding() {
  const windowWidth = window.innerWidth;
  if (windowWidth < 1024) return 15;
  return 40;
}

function updateSlideWidth() {
  const pageWidth = Math.min(window.innerWidth, 2000);
  const isMobile = pageWidth < 1024;
  const pageWidthPadding = getPageWidthPadding() * 2;
  let gapBetweenCards = 12;
  if (pageWidth == 2000) {
    gapBetweenCards = 9;
  }
  const multiplier = isMobile ? 0.85 : 0.25;
  const slideWidth =
    (pageWidth - pageWidthPadding) * multiplier - gapBetweenCards;
  document.documentElement.style.setProperty(
    "--slide-width",
    `${slideWidth}px`
  );
}

window.addEventListener("resize", updateSlideWidth);
updateSlideWidth();
